<template>
    <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 16 16" fill="none">
        <path
            d="M12.5709 0.571289H3.42801C2.79684 0.571289 2.28516 1.08296 2.28516 1.71415V14.2856C2.28516 14.9168 2.79684 15.4284 3.42801 15.4284H12.5709C13.2021 15.4284 13.7137 14.9168 13.7137 14.2856V1.71415C13.7137 1.08296 13.2021 0.571289 12.5709 0.571289Z"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M7.99972 13.1425C9.57768 13.1425 10.8569 11.8633 10.8569 10.2854C10.8569 8.70741 9.57768 7.42822 7.99972 7.42822C6.42177 7.42822 5.14258 8.70741 5.14258 10.2854C5.14258 11.8633 6.42177 13.1425 7.99972 13.1425Z"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M7.9986 10.5714C7.84081 10.5714 7.71289 10.4435 7.71289 10.2857C7.71289 10.1279 7.84081 10 7.9986 10"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M7.99805 10.5714C8.15584 10.5714 8.28376 10.4435 8.28376 10.2857C8.28376 10.1279 8.15584 10 7.99805 10"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M7.99888 4.42843C7.76219 4.42843 7.57031 4.23656 7.57031 3.99986C7.57031 3.76316 7.76219 3.57129 7.99888 3.57129"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
        <path
            d="M7.99805 4.42843C8.23474 4.42843 8.42662 4.23656 8.42662 3.99986C8.42662 3.76316 8.23474 3.57129 7.99805 3.57129"
            stroke="#4A4A4A"
            stroke-linecap="round"
            stroke-linejoin="round"
        />
    </svg>
</template>
